<div class="container-fluid">
    <section id="login" class="row">
        <div class="blue-strip"></div>

        <h1>OmniMais</h1>

        <div class="box">
            <div *ngIf="isLogin()">
                <h2>Login</h2>

                <div class="form-group">
                    <label class="sr-only" for="user-login">Usuário</label>
                    <input [(ngModel)]="credencial.login" (keyup)="onKeyup($event)" (ngModelChange)="credencial.login = $event.toUpperCase()" name="login" type="text" class="form-control" id="user-login"
                        placeholder="Usuário" required tabindex="1" [disabled]="isLoggingIn">
                </div>

                <div class="form-group">
                    <label class="sr-only" for="user-password">Senha</label>
                    <input [(ngModel)]="credencial.senha" (keyup)="onKeyup($event)" (ngModelChange)="credencial.senha = $event.toUpperCase()" name="senha" type="password" class="form-control" id="user-password"
                        placeholder="Senha" required tabindex="2" [disabled]="isLoggingIn">
                </div>

                <a (click)="changePassword()" class="change-password" tabindex="6" [ngClass]="{'disabled': isLoggingIn}">Alterar a Senha</a>

                <a (click)="recoveryPassword()" class="password-recovery" tabindex="7" [ngClass]="{'disabled': isLoggingIn}">Esqueceu sua senha?</a>

                <a (click)="login()" class="btn btn-login btn-sign" [ngClass]="{'disabled': isLoggingIn}" tabindex="3">
                    <span *ngIf="isLoggingIn">Efetuando login...</span>
                    <span *ngIf="!isLoggingIn">Entrar</span>
                </a>

                <div class="clear"></div>
            </div>

            <div *ngIf="isRecoveryPassword()">
                <a (click)="back()" class="password-back">
                    <em class="fa fa-arrow-left" aria-hidden="true"></em>
                </a>

                <h2>Esqueceu sua senha?</h2>
                <p class="text-center">Para redefinir sua senha preencha o campo abaixo:</p>

                <div class="form-group">
                    <label class="sr-only" for="user-login">Usuário</label>
                    <input [(ngModel)]="credencial.login" (keyup)="onKeyup($event)" (ngModelChange)="credencial.login = $event.toUpperCase()" name="login" type="text" class="form-control" id="user-login"
                        placeholder="Usuário" tabindex="1">
                </div>

                <a (click)="sendRecoveryPassword()" class="btn btn-login btn-sign" tabindex="3">Receber senha por e-mail</a>
            </div>

          <div *ngIf="isChangePassword()">
            <a (click)="back()" class="password-back">
              <em class="fa fa-arrow-left" aria-hidden="true"></em>
            </a>

            <h2>Alterar a Senha</h2>
            <p class="text-center">Para redefinir sua senha preencha os campos abaixo:</p>

            <div class="form-group">
              <label class="sr-only" for="user-login">Usuário</label>
              <input [(ngModel)]="changePasswordCredential.login" (keyup)="onKeyup($event)" (ngModelChange)="changePasswordCredential.login = $event.toUpperCase()" name="login" type="text" class="form-control" id="user-login"
                     placeholder="Usuário" tabindex="1">
            </div>

            <div class="form-group">
              <label class="sr-only" for="user-password">Senha Atual</label>
              <input [(ngModel)]="changePasswordCredential.oldPassword" (keyup)="onKeyup($event)" (ngModelChange)="changePasswordCredential.oldPassword = $event.toUpperCase()" name="senha" type="password" class="form-control" id="current-password"
                     placeholder="Senha Atual" required tabindex="2" [disabled]="isLoggingIn">
            </div>

            <div class="form-group">
              <label class="sr-only" for="user-password">Nova Senha</label>
              <input [(ngModel)]="changePasswordCredential.newPassword" (keyup)="onKeyup($event)" (ngModelChange)="changePasswordCredential.newPassword = $event.toUpperCase()" name="nova_senha" type="password" class="form-control" id="new-password"
                     placeholder="Nova Senha" required tabindex="2" [disabled]="isLoggingIn">
            </div>

            <div class="form-group">
              <label class="sr-only" for="user-password">Confirmar Nova Senha</label>
              <input [(ngModel)]="changePasswordCredential.newPasswordConfirmed" (keyup)="onKeyup($event)" (ngModelChange)="changePasswordCredential.newPasswordConfirmed = $event.toUpperCase()" name="nova_senha_confirm" type="password" class="form-control" id="new-password-confirm"
                     placeholder="Confirmar Nova Senha" required tabindex="2" [disabled]="isLoggingIn">
            </div>

            <a (click)="sendChangePassword()" class="btn btn-login btn-sign" tabindex="3">Alterar Senha</a>
          </div>

            <div *ngIf="isMessage()">
                <a (click)="back()" class="password-back">
                    <em class="fa fa-arrow-left" aria-hidden="true"></em>
                </a>
                <p class="text-center message">{{message}}</p>
            </div>
        </div>
    </section>

    <div class="logo-container">
        <h2 class="omni-enterprises">Omni Soluções Financeiras</h2>
        <p>Versão {{version}}</p>
    </div>
</div>

<app-modal #expiredPassword [ignoreBackdropClick]="true" title="Alerta" labelClose="Cancelar" labelOk="OK">
  <p>Sua senha expirou!<br>Deseja alterá-la agora?</p>
</app-modal>

<app-modal #attemptLimit [ignoreBackdropClick]="true" title="Alerta" hideClose="true">
    <p>Você ultrapassou o número de tentativas permitidas<br>A próxima será bloqueada!</p>
</app-modal>

<app-select-agente #selecionarAgente></app-select-agente>
<app-modal-message #modalMessage [hideClose]="true" title="Atenção">
</app-modal-message>
